import { apiClient } from 'src/lib/apiClient';

export interface SupportRequest {
  subject: string;
  message: string;
  contactNumber?: string;
  merchantId?: number;
}

export const submitSupportRequest = async (request: SupportRequest): Promise<void> => {
  try {
    await apiClient.post('support', request);
  } catch (error) {
    console.error('Error submitting support request:', error);
    throw error;
  }
};
